<template>
  <div class="container ">
    <div class="mt-4 mb-2 d-flex justify-content-end">
      <b-button
        id="toggle-btn"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        v-b-modal.modal-add-modulo
        modal-sm
        variant="primary"
      >
        Adicionar Módulo
      </b-button>
      <b-modal
        id="modal-add-modulo"
        ok-only
        ok-title="Salvar"
        centered
        size="lg"
        title="Criar Modulo"
        @ok="criarModulo()"
      >
        <b-form-group
          label="Nome Modulo"
          label-for="nome-modulo"
        >
          <b-form-input
            id="nome-modulo"
            v-model="module.modulo_name"
            style="outline: 0"
            placeholder="Nome Aluno"
          />
        </b-form-group>
      </b-modal>
      <modal-editar-modulo ref="child" />
    </div>
    <div
      v-for="(module, index) in modulos"
      id="list-all-modulo"
      :key="index"
      class="card"
      draggable="true"
      @dragstart="dragStartadmin(module.id, index)"
      @dragover.prevent
      @drop.prevent="dropEnd(module.id, index, modulos)"
    >

      <div class="row justify-content-center input-container">
        <div class="d-flex align-items-center">
          <feather-icon
            icon="MenuIcon"
            size="18"
            stroke="red"
            class="mr-50 mb-2"
          />

          <div
            class="flex-grow-1"
            style="margin-right: 25px;"
          >
            <input
              ref="moduleInput"
              v-model="module.modulo_name"
              type="text"
              placeholder="Digite o nome do conteúdo"
              class="form-control mr-2"
              @input="updateModulo(module)"
            >
          </div>
          <div
            class="flex-grow-2"
            style="margin-right: 25px;"
          >
            <!--            <b-badge variant="light-primary">-->
            <!--              {{ module.conteudo.length }} Conteúdos-->
            <!--            </b-badge>-->
          </div>
          <div class="row-cols-sm-1 mt-auto">
            <el-dropdown trigger="click">
              <b-button
                id="acoes-modulo"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="gradient-primary"
                class="btn-icon"
              >
                <feather-icon icon="MoreVerticalIcon" />
              </b-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-edit-outline">
                  <span @click="showModal(module)">
                    Editar módulo
                  </span>
                </el-dropdown-item>
                <el-dropdown-item
                  icon="el-icon-delete"
                >
                  <span @click="() => deleteModulo(module.id)">Excluir módulo</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="col-sm-1">
        <el-dropdown
          trigger="click"
        >
          <b-button
            id="add-conteudo"
            variant="gradient-danger"
            class="btn-icon rounded-circle"
          >
            <feather-icon icon="PlusIcon" />
          </b-button>
          <el-dropdown-menu slot="dropdown">
            <!--            <el-dropdown-item>-->
            <!--              <feather-icon-->
            <!--                icon="LayersIcon"-->
            <!--                size="18"-->
            <!--                class="mr-50"-->
            <!--              />-->
            <!--              <span @click="showModalAdd() ">Adicionar módulo</span>-->
            <!--            </el-dropdown-item>-->
            <b-link
              :to="{ name: 'addConteudo', params: { id: module.id } }"
              class="font-weight-bold d-block text-nowrap"
              @click="gerarUidConteudo"
            >
              <el-dropdown-item>
                <feather-icon
                  icon="FilePlusIcon"
                  size="18"
                  class="mr-50"
                />
                <span>Adicionar conteudo</span>
              </el-dropdown-item>
            </b-link>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <button
        class="collapsible"
        data-bs-toggle="collapse"
        :data-bs-target="`#collapse_${index}`"
        :aria-expanded="index === 0 ? 'true' : 'false'"
        :aria-controls="`collapse_${index}`"
      />
      <div
        v-for="(content, contentIndex) in module.conteudo"
        :id="`collapse_${index}`"
        :key="contentIndex"
        :class="{ show: index === 0 }"
        class="content"
        :style="{ maxHeight: module.isModuleCollapsed ? '0' : '100%' }"
        draggable="true"
        @dragstart="dragStart(content.id, contentIndex)"
        @dragover.prevent
        @drop.prevent="drop(content.id, contentIndex, module)"
      >
        <p />
        <div
          class="row justify-content-center input-container"
        >
          <div class="d-flex align-items-center">
            <feather-icon
              icon="MenuIcon"
              size="18"
              stroke="red"
              class="mr-50"
            />
            <div class="flex-grow-1">
              <input
                v-model="content.titulo"
                type="text"
                placeholder="Digite o nome do conteúdo"
                class="form-control mr-3"
                @input="updateConteudo(content)"
              >
            </div>
            <div
              class="btn-group me-2 ms-3"
              role="group"
              aria-label="First group"
            >
              <b-button-group
                size="sm"
              >
                <b-button
                  id="editar-conteudo-modulo"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  :to="{ name: 'editConteudo'}"
                  @click="guardarIdCanteudoUid(content.id, content.uid)"
                >
                  <feather-icon
                    icon="Edit2Icon"
                    size="18"
                    class="mr-50"
                  />

                </b-button>
                <b-button
                  id="deletar-conteudo-modulo"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  @click="confirmText(content.id)"
                >
                  <feather-icon
                    icon="Trash2Icon"
                    size="18"
                    class="mr-50"
                  />
                </b-button>
              </b-button-group>
            </div>
          </div>
        </div>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BBadge, BButton, BFormGroup, BFormInput, BModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ModalAddModulo from '@/views/App/Treinamentos/TreinamentosAdmin/ModalAddModulo.vue'
import store from '@/store'
import moduloTreStore from '@/store/ModuloTrei/moduloTreStore'
import { ref, onUnmounted } from '@vue/composition-api'

import ConteudoService from '@/services/Conteudo'
import { ModuloService } from '@/services/Modulo'
import ModalEditarModulo from '@/views/App/Treinamentos/TreinamentosAdmin/modalEditarModulo.vue'
import { useApi } from '@/composables/useApi'
import InputFileCustom from '@/views/App/Cursos/InputFileCustom.vue'

const conteudoService = new ConteudoService()
const apiBack = useApi()
export default {
  components: {
    InputFileCustom,
    BModal,
    BFormInput,
    BFormGroup,
    ModalEditarModulo,
    // eslint-disable-next-line vue/no-unused-components
    ModalAddModulo,
    BButton,
    BBadge,

  },
  directives: {
    Ripple,
  },

  data() {
    return {
      cursoId: this.$route.params.id,
      modulos: [],
      dragContent: null,
      dragContentIndex: null,
      isCollapsed: true,
      contentName: '',
      module: {
        modulo_name: '',
        modulo_ativo: '',
      },
      conteudo: {
        conteudo_titulo: '',
        modulo_id: '',
        conteudo_content: '',
        conteudo_files: '',
        conteudo_video_url: '',
      },
    }
  },

  setup() {
    const moduloData = ref([])

    const USER_APP_STORE_MODULE_NAME = 'app-modulo'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, moduloTreStore)

    // Unregister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const refreshModuloData = async () => {
      await store.dispatch('app-modulo/fetchModulosConteudo')
        .then(response => { moduloData.value = response.data })
        .catch(error => {
          if (error.response.status === 404) {
            moduloData.value = undefined
          }
        })
    }

    window.addEventListener('refresh', () => {
      // Lógica para atualizar os dados
      refreshModuloData()
    })
    onUnmounted(() => {
      window.removeEventListener('refresh', () => {
        // Lógica para atualizar os dados
        refreshModuloData()
      })
    })
    const deleteModulo = async id => {
      await
      store.dispatch('app-modulo/deleteModulo', id)
        .then(() => {
          refreshModuloData()
        })
    }
    const deleteConteudo = async id => {
      await conteudoService.ConteudoDelete(id)
        .then(() => {
          this.buscarModulo()
        })
    }

    return {
      moduloData,
      refreshModuloData,
      deleteModulo,
      deleteConteudo,
    }
  },

  mounted() {
    this.buscarModulo()
    // feather.replace()
  },
  methods: {
    async criarModulo() {
      console.log(this.modulos.length + 1)

      await apiBack.post('/addModuloCurso', {
        nome: this.module.modulo_name,
        ordem: this.modulos.length + 1,
        id_curso: this.cursoId,
      })
        .then(() => {
          this.buscarModulo()
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })
        .catch(err => console.error(err))
    },
    async buscarModulo() {
      await apiBack.get(`/getModuloByIdCursoController?id_curso=${this.cursoId}`)
        .then(data => {
          console.log(data.data)
          this.modulos = data.data
        })
        .catch(err => console.error(err))
    },
    ViewConteudo(value) {
      this.$router.push({ name: 'Treinamentos', params: { id: value.id } })
    },

    async updateModulo(conteudo) {
      const { id, modulo_name, modulo_ativo } = conteudo
      this.module = {
        modulo_name,
        modulo_ativo,
      }
      this.updateModuloname(id)
    },
    async updateModuloname(id) {
      const moduloService = new ModuloService()
      await moduloService.UpdateModulo(id, this.module)
        .then(() => {
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    async updateConteudo(content) {
      const { id, modulo_id, titulo } = content
      this.conteudo = {
        conteudo_titulo: titulo,
        modulo_id,
        conteudo_content: '',
        conteudo_files: '',
        conteudo_video_url: '',
      }
      await conteudoService.ConteudoById(id).then(response => {
        this.conteudo.conteudo_content = response.conteudo_content
        this.conteudo.conteudo_video_url = response.conteudo_video_url
        this.conteudo.modulo_id = response.modulo_id
      })
      this.updateConteudoname(id)
    },
    async updateConteudoname(id) {
      await conteudoService.UpdatConteudo(id, this.conteudo)
        .then(() => {

        })
        .catch(error => {
          console.log('error', error)
        })
    },
    showModal(module) {
      this.$refs.child.modalToggle(module)
    },
    dragStart(id) {
      this.draggedItemId = id
    },
    drop(id, contentIndex, module) {
      const draggedItem = module.conteudo.find(content => content.id === this.draggedItemId)
      const droppedItem = module.conteudo.find(content => content.id === id)
      const draggedItemOrder = draggedItem.ordem
      draggedItem.ordem = droppedItem.ordem
      droppedItem.ordem = draggedItemOrder
      module.conteudo.sort((a, b) => a.ordem - b.ordem)
      // Atualiza os números de sequência das mensagens do array atual

      module.conteudo.forEach((conteudo, indice) => {
        console.log('msg', conteudo)
        conteudo.ordem = indice + 1
        this.updateOrdemConteudo(conteudo)
      })
    },
    async updateOrdemConteudo(conteudo) {
      console.log(conteudo)
      const {
        id, ordem, titulo, content, modulo_id,
      } = conteudo
      const res = await conteudoService.ConteudoById(id).catch(error => {
        console.log(error)
      })
      const filesConteudo = {
        conteudo_titulo: titulo,
        modulo_id,
        conteudo_content: content,
        conteudo_files: '',
        conteudo_video_url: res.conteudo_video_url,
        conteudo_sequencia: ordem,
      }

      await conteudoService.UpdatConteudo(id, filesConteudo)
        .then(() => {})
        .catch(error => {
          console.log(error)
        })
    },
    dragStartadmin(id) {
      this.draggedItemIdadmin = id
    },
    dropEnd(id, index, modulos) {
      console.log(id, index, modulos)
      const draggedItem = modulos.find(modulo => modulo.id === this.draggedItemIdadmin)
      const droppedItem = modulos.find(modulo => modulo.id === id)
      const draggedItemOrder = draggedItem.modulo_ordem

      draggedItem.modulo_ordem = droppedItem.modulo_ordem

      droppedItem.modulo_ordem = draggedItemOrder
      modulos.sort((a, b) => a.modulo_ordem - b.modulo_ordem)

      modulos.forEach(modulo => {
        this.updateOrdemModulo(modulo)
      })
    },
    async updateOrdemModulo(conteudo) {
      const moduloService = new ModuloService()
      const {
        id, modulo_name, modulo_ativo, modulo_ordem,
      } = conteudo

      const filesModulo = {
        modulo_name,
        modulo_ativo,
        modulo_ordem,
      }
      await moduloService.UpdateModulo(id, filesModulo)
        .then(() => {

        })
        .catch(error => {
          console.log(error)
        })
    },
    gerarUidConteudo() {
      const uid = Math.floor(Math.random() * 1000000000000).toString().padStart(13, '0')
      localStorage.setItem('uidConteudo', uid)
    },
    guardarIdCanteudoUid(idConteudo, uid) {
      localStorage.setItem('cursoId', this.cursoId)
      localStorage.setItem('idConteudo', idConteudo)
      localStorage.setItem('uidConteudo', uid)
    },

    async confirmText(id) {
      this.$swal({
        title: 'Você tem certeza que deseja excluir?',
        text: 'Você não será capaz de reverter isso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          await apiBack.get(`/deleteConteudo/${id}`)
            .then(() => {
              this.buscarModulo()
              this.$swal({
                icon: 'success',
                title: 'Excluído!',
                text: 'O conteúdo foi excluído.',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            })
            .catch(err => console.error(err))
        }
      })
    },

  },

}

</script>
<style scoped>
.collapsible {
  background-color: #ffffff;
  color: #4b5563;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 17px;
  position: relative;
}

.active, .collapsible:hover {
  background-color: #eef0f1;
}

.collapsible:before {
  content: "\23F7";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.active:before {
  content: "\23F6";
}

.content {
  margin-top: -1px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
  background-color: #ffffff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-top: 1px solid #ccc;
  margin-left: 0px;
}
.active, .content:hover {
  background-color: #f5f5f5;
}
.content i {
  margin-right: 8px;
}
.content[draggable]:hover {
  cursor: move;
}

.card[draggable]:hover {
  cursor: move;
}

.row {
  --bs-gutter-x: -2.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-.5 * var(--bs-gutter-x));
  margin-left: calc(-.5 * var(--bs-gutter-x));
}
.input-row {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.input-row i {
  margin-right: 10px;
}

/* input*/

.form-control {
  border: none;
  border-bottom: 2px dotted black;

  border-radius: 0;
  outline: none; /* opcional: remove a linha pontilhada quando o input estiver focado */
}
.w-full {
  width: 90%;
}
.border-b {
  border-bottom-width: 1px;
}

.input-container {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.input-container i {
  margin-right: 10px;
}

.input-container .form-control {
  margin-left: 5px;
}
.no-outline:focus {
  outline: none;
  box-shadow: none;
}

/*card*/
.card {
  max-width: 100%;
}

/*.collapsible {*/
/*  width: 30px; !* exemplo de valor *!*/
/*}*/

</style>
